import { get, post } from '../../common/ApiClient';
import { SubscriptionResponse } from 'subscriptions/types/Subscription';
import { BusinessSubChildrenResponse } from 'subscriptions/types/Subscription'; // Define the correct type for the response

export const getSubscriptions = async (
  showFinished: boolean,
  useToken: boolean = true
): Promise<SubscriptionResponse> => {
  const { data } = await get<any>('/users/subscriptions', useToken, undefined, {
    show_finished: showFinished.toString(),
  });
  return data;
};

export const getBusinessSubChildren = async (subscriptionId: number): Promise<BusinessSubChildrenResponse> => {
  try {
    const response = await get<any>('/users/family-subscription-codes', true, undefined, {
      subscription_id: subscriptionId.toString(),
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching business subscription children', error);
    throw error; // Rethrow the error to be handled by the component
  }
};

export const stopRecurrentPayment = async (paymentId: number): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append('id', paymentId.toString());
    await post<any>('/recurrent-payment/stop', true, formData, {}, { isJson: true });
  } catch (error) {
    console.error('Error stopping recurrent payment', error);
    throw error; // Rethrow the error to be handled by the component
  }
};
